import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import moment from 'moment';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PageTracker from '../../../common/PageTrackerHelper'
import keycloak from '../../../common/Keycloak';

export default {
  name: 'SetSRTripConfiguration',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect
  },
  mixins:[PageTracker],
  data: function() {
    return {
      pageno: 0,
      pagecount: 0,
      localhubdetails:'',
      localuserid:'',
      srArrayList: [],
      IscheckedSRList: [],
      isTripAllowedForSR: '',
      isSRTripLoader: false,
      search: '',
      isLoading: false,
      userDataKey : '',
    }
  },
  created: function() {
  },
  computed: {
    filteredSRList:function() {
        var self=this;
        return this.srArrayList.filter(function(emp){
          if(emp.DeliverySRName.toLowerCase().indexOf(self.search.toLowerCase())>=0){
            return emp.DeliverySRName.toLowerCase().indexOf(self.search.toLowerCase())>=0;
          } else if(emp.DeliverySRIds.toLowerCase().indexOf(self.search.toLowerCase())>=0){
            return emp.DeliverySRIds.toLowerCase().indexOf(self.search.toLowerCase())>=0;
          }
        });
        //return this.customers;
     }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.loadSRList();

  },
  filters: {
    changeDateFormat: function(date) {
      if (typeof date === "object" && !date) {
        return '';
      } else {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
    }
  },
  methods: {

    loadSRList() {
      //this.srLoader = this.loader
      this.isLoading = true;
      this.srArrayList = []
      this.srList = []
      if(this.localhubdetails) {
        this.input = {
          "usertype":"3",
        	"hubid":[this.localhubdetails]
        }
        let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
        if (keycloak.enableKavach) {
            apiendpoint = 'user/migration/gethubdeliveryuserlist';
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + apiendpoint,
          data: this.input
        })
        .then(result => {
          //console.log('result.data',result.data.data.);
          if (result.data.data.code == 200) {
            //this.srArrayList = result.data.data.results;
            let getResponse = result.data.data.results;
            //console.log('this.srArrayList',this.srArrayList);
            let cnt = getResponse.length;
            for (var i = 0; i < cnt; i++) {
              let obj = {};
              obj.DeliverySRName = `${getResponse[i].FirstName} ${getResponse[i].LastName}`;
              obj.DeliverySRIds = `( ${getResponse[i].OldDeliveryUserOrUserId} - ${getResponse[i].userid} )`;
              obj.userid = getResponse[i].userid;
              obj.OldDeliveryUserOrUserId = getResponse[i].OldDeliveryUserOrUserId;
              obj.modifieddatetime = getResponse[i].modifieddatetime;
              obj.lastmodifiedby = getResponse[i].lastmodifiedby;
              obj.isTripAllowedForSR = getResponse[i].isTripAllowedForSR;
              this.srArrayList.push(obj);
              if(getResponse[i].isTripAllowedForSR == true) {
                this.IscheckedSRList.push(getResponse[i].userid)
              }
            }
            //console.log('this.IscheckedSRList',this.srArrayList);
          } else {
            this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },
    SetSRTripConfiguration(e,userid,value,OldDeliveryUserOrUserId){

      let message = {
        title: '',
        body: `<p>You will not be allowed to enable/disable the trip again today. Do you want to continue ? </p> `,
      };

      let res = this.$dialog.confirm(message, {
        html: true,
        animation: 'bounce',
        backdropClose: true,
        okText: 'Yes',
        cancelText: 'No',
        reverse: true,
        loader: true
      })
      .then(dialog => {

        //console.log('Yes...');
        //this.isSRTripLoader = true;
        //checked if SR has allocated shipments
        let allocatePayload = {
          "HubId": this.localhubdetails.toString(),
          "DeliveryUserId": userid
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'expose/get/allocate/ofd/shipment/sr/details',
          data: allocatePayload
        })
        .then(result => {
          if(result.data.code != 200) {
            let TrackerInfo = {
              projectname:"Last Mile",
              type:"Web",
              userid:this.localuserid,
              username:this.localusermailid,
              meta: {
                  "event":"tripConfigurationAction",
                  "DeliveryUserId": userid
              }
            }
            this.PageTracker(TrackerInfo);
            //check trip validation
            let TripPayload = {
              "XBkey":"XB123",
            	"HubId":this.localhubdetails,
            	"DeliveryUserId":userid
            }
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'expose/trip/tripDetails',
              data: TripPayload
            })
            .then(result => {
              if (result.data.TripState=="closed") {
                let TripFlagSrt = value == true ? false : true;
                //set SR Trip TripConfiguration
                let TypeCastuserid = parseInt(userid);
                let srtripPayload = {
                  "userid" : TypeCastuserid,
                  "isTripAllowedForSR" : TripFlagSrt,
                  "lastmodifiedby": this.localusermailid
                }
                
                let apiendpoint = 'external/SetDeliveryuserTripStatus';
                if (keycloak.enableKavach) {
                  srtripPayload.hubid = parseInt(this.localhubdetails);
                  apiendpoint = 'user/migration/setusertripstatus';
                }
                axios({
                  method: 'POST',
                  url: apiUrl.api_url + apiendpoint,
                  data: srtripPayload
                })
                .then(result => {
                  console.log('SetDeliveryuserTripStatus result',result);
                  dialog.close();
                  if(result.data.code == 200){
                    this.$alertify.success(result.data.data.result);
                    let migrationData = {
                      "DeliveryUserId": OldDeliveryUserOrUserId,
                      "LastModifiedBy": this.localusermailid,
                      "IsAllowKilometer": TripFlagSrt == true ? 1 : 0
                    }
                    this.Update_Trip_migration_new_to_old(migrationData);
                  } else {
                    if(value == true) {
                      this.IscheckedSRList.push(userid);
                    } else {
                      this.IscheckedSRList.splice( this.IscheckedSRList.indexOf(userid), 1 );
                    }
                    this.$alertify.error(result.data.data.result);
                  }
                  //this.IscheckedSRList = [];
                  //this.isSRTripLoader = false;
                  this.loadSRList();
                })
              } else {
                dialog.close();
                if(value == true) {
                  this.IscheckedSRList.push(userid);
                } else {
                  this.IscheckedSRList.splice( this.IscheckedSRList.indexOf(userid), 1 );
                }
                this.$alertify.error("Can't Enable / Disable , Please check SR trip need to closed state.! ");
              }
            })
          } else {
            dialog.close();
            if(value == true) {
              this.IscheckedSRList.push(userid);
            } else {
              this.IscheckedSRList.splice( this.IscheckedSRList.indexOf(userid), 1 );
            }
            this.$alertify.error("Can't Enable / Disable , Please clear Shipment Allocated to SR.! ");
          }
        }, error => {
          this.isLoadingASL = false
          console.error(error)
        })
        //this.$refs.shipmentNo.focus();
        //console.log('res',res);
        //dialog.close();
      })
      .catch(() => {
        //console.log('no...');
        if(value == true) {
          this.IscheckedSRList.push(userid);
        } else {
          this.IscheckedSRList.splice( this.IscheckedSRList.indexOf(userid), 1 );
        }
      })
    },
    Update_Trip_migration_new_to_old(payload) {
      axios({
        method: 'POST',
        headers: {"content-type": "application/json"},
        url: apiUrl.api_url + 'expose/trip/allocation/restriction/newToOld/migration',
        data: payload
      })
      .then( result => {
        console.log('migration Result : ', result);
      })
    },
    resetForm() {
      this.Tripsingle = {};
      this.hubname = this.localhubdetails;
      this.pageno = 1;
      this.closekm = '';
      this.tripreason = '';
      this.errors.clear();
      this.$validator.reset();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/SetSRTripConfiguration/SetSRTripConfiguration.component.js